import siteMapSlice from './slice';

export const {
    fetchSiteMapError,
    fetchSiteMap,
    fetchSiteMapSuccess,
    createSiteMapError,
    createSiteMap,
    createSiteMapSuccess,
    deleteSiteMapError,
    deleteSiteMap,
    deleteSiteMapSuccess,
    updateSiteMapError,
    updateSiteMap,
    updateSiteMapSuccess,
    siteMapinit,    
    reorderSiteMapError,
    reorderSiteMap,
    reorderSiteMapSuccess,

    sitemapUrlsAddError,
    sitemapUrlsAdd,
    sitemapUrlsAddSuccess,

    fetchSiteMapCreating,
    fetchSiteMapEndCreating,

    updateSiteMapFromUrlError,
    updateSiteMapFromUrl,
    updateSiteMapFromUrlSuccess,
    

    DeleteAllSitemapError,
    DeleteAllSitemap,
    DeleteAllSitemapSuccess,

} = siteMapSlice.actions;
export default siteMapSlice.reducer;

export * from './types';
